import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import BriefDescription from 'components/commons/BriefDescription';
import BriefAudioPlayer from 'components/commons/BriefAudioPlayer';
import React, { useState } from 'react';

var BriefListElement = function BriefListElement(_ref) {
  var brief = _ref.brief,
      onClicked = _ref.onClicked;

  var _useState = useState(brief.translations[0]),
      currentTranslation = _useState[0],
      setCurrentTranslation = _useState[1];

  var onChangedTranslation = function onChangedTranslation(translation) {
    debugger;
    setCurrentTranslation(translation);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "BriefListElement",
    children: [/*#__PURE__*/_jsx(BriefDescription, {
      brief: brief,
      translation: currentTranslation,
      onClicked: onClicked
    }), /*#__PURE__*/_jsx("div", {
      className: "flexRow bottomRow",
      children: /*#__PURE__*/_jsx(BriefAudioPlayer, {
        onChangedTranslation: onChangedTranslation,
        brief: brief,
        translation: currentTranslation
      })
    })]
  });
};

export default BriefListElement;